var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWeareoneLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 194.82 199.98",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: url(#Sfumatura_senza_nome_4);\n      }\n\n      .cls-1, .cls-2 {\n        stroke-width: 0px;\n      }\n\n      .cls-2 {\n        fill: #fff;\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Sfumatura_senza_nome_4",
    "data-name": "Sfumatura senza nome 4",
    x1: 7.51,
    y1: 103.49,
    x2: 192.41,
    y2: 83.57,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#e51576"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#e51576"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e31f13"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Street_Right",
    "data-name": "Street Right"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M169.63,32.04c15.65,17.29,25.19,40.21,25.19,65.37,0,11.35-1.96,22.24-5.52,32.36h-9c-5.9,0-10.67-4.78-10.67-10.68V32.04ZM70.62,129.78h16.12c5.9,0,10.67-4.78,10.67-10.68v-56.06c0-5.9-4.78-10.68-10.67-10.68h-17.59v-27.53c9.83-.82,16.8-3.07,20.9-6.76,4.09-3.69,6.55-9.71,7.37-18.07C43.62,0,0,43.61,0,97.41c0,44.5,29.85,82.01,70.62,93.65v-61.29Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M101.07,157.78c11.18,0,18.93,6.14,18.93,17.36s-7.75,17.36-18.93,17.36-18.98-6.14-18.98-17.36,7.8-17.36,18.98-17.36ZM101.07,183.32c4.71,0,7.75-3.47,7.75-8.18s-3.04-8.18-7.75-8.18-7.8,3.47-7.8,8.18,3.09,8.18,7.8,8.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M142.74,191.93l-11.84-19.36v19.36h-8.51v-33.58h11.42l11.03,18.74v-18.74h8.51v33.58h-10.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M166.48,191.93c-5.18,0-9.56-3.28-9.56-8.7v-24.88h24.83l-1.19,8.13h-13.55v4.71h12.41l-1.19,7.9h-11.22v1.33c0,1.81.76,3.38,2.9,3.38h11.79l-1.24,8.13h-13.98Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M83.39,138.49h1.7l3.82,12.96,3.36-12.96h1.46l3.53,12.96,3.64-12.96h1.7l-4.66,15.59h-1.5l-3.44-12.87-3.33,12.87h-1.5l-4.77-15.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M111.87,154.07c-2.21,0-3.49-1.08-3.49-3.29v-12.3h10.31l-.31,1.44h-8.37v5.67h7.44l-.31,1.35h-7.13v3.84c0,1.28.57,1.85,1.85,1.85h6.65l-.31,1.44h-6.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M143.93,149.72h-6.91l-1.59,4.35h-1.68l5.83-15.59h1.81l5.83,15.59h-1.68l-1.61-4.35ZM137.55,148.31h5.87l-2.94-7.95-2.94,7.95Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M160.13,138.49c3.38,0,4.79,2.3,4.79,4.68,0,2.56-1.83,4.48-4.08,4.44,2.41.33,2.78,2.89,3.51,4.55.31.68.75,1.57,1.06,1.92h-2.01c-.15-.15-.42-.64-.68-1.32-1.02-2.61-1.3-4.92-4.81-4.92l-1.9-.02c-1.41,0-1.46-.46-1.74-.91v7.18h-1.63v-15.59h7.51ZM154.26,144.71c0,.91.57,1.7,1.85,1.7h3.8c2.05,0,3.22-1.28,3.22-3.22,0-2.38-1.32-3.29-3.33-3.29h-5.54v4.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M174.86,154.07c-2.21,0-3.49-1.08-3.49-3.29v-12.3h10.31l-.31,1.44h-8.37v5.67h7.44l-.31,1.35h-7.13v3.84c0,1.28.57,1.85,1.85,1.85h6.65l-.31,1.44h-6.34Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M83.6,196.12h.77v3.79h-.77v-3.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M86.06,199.91c-.56,0-.97-.32-.97-.89v-2.9h.77v2.73c0,.26.11.41.39.41h1.47l-.11.65h-1.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M89.9,199.05c.34.19.68.3,1.04.3s.61-.12.61-.46c0-.3-.31-.46-.6-.59l-.46-.2c-.51-.23-.84-.5-.84-1.02,0-.7.66-1.02,1.4-1.02.42,0,.83.09,1.24.28l-.27.63c-.3-.2-.62-.28-.92-.28s-.62.07-.62.38c0,.26.32.38.58.5l.44.2c.55.26.88.55.88,1.12,0,.76-.65,1.1-1.43,1.1-.43,0-.89-.08-1.32-.28l.27-.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M92.9,196.12h.77v2.36c0,.6.43.82.9.82.51,0,.9-.24.9-.82v-2.36h.71v2.46c0,.97-.72,1.4-1.61,1.4-.82,0-1.67-.37-1.67-1.4v-2.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M98.72,196.06c.4,0,.78.09,1.11.26l-.3.6c-.18-.1-.42-.18-.71-.18-.76,0-1.25.52-1.25,1.27,0,.79.55,1.29,1.32,1.29.34,0,.57-.09.78-.19l-.08.69c-.19.08-.49.17-.87.17-1.17,0-2.01-.76-2-1.97,0-1.21.85-1.96,2-1.96Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M102.09,196.06c.4,0,.78.09,1.11.26l-.3.6c-.18-.1-.42-.18-.71-.18-.76,0-1.25.52-1.25,1.27,0,.79.55,1.29,1.32,1.29.34,0,.57-.09.78-.19l-.08.69c-.19.08-.49.17-.87.17-1.17,0-2.01-.76-2-1.97,0-1.21.85-1.96,2-1.96Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M104.57,199.91c-.56,0-.97-.32-.97-.89v-2.9h2.66l-.11.63h-1.78v.96h1.61l-.1.61h-1.5v.54c0,.26.11.41.39.41h1.47l-.11.63h-1.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M106.86,199.05c.34.19.68.3,1.04.3s.61-.12.61-.46c0-.3-.31-.46-.6-.59l-.46-.2c-.51-.23-.84-.5-.84-1.02,0-.7.66-1.02,1.4-1.02.42,0,.83.09,1.24.28l-.27.63c-.3-.2-.62-.28-.92-.28s-.62.07-.62.38c0,.26.32.38.58.5l.44.2c.55.26.88.55.88,1.12,0,.76-.65,1.1-1.43,1.1-.44,0-.89-.08-1.32-.28l.27-.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M109.94,199.05c.34.19.68.3,1.04.3s.61-.12.61-.46c0-.3-.31-.46-.6-.59l-.46-.2c-.51-.23-.84-.5-.84-1.02,0-.7.66-1.02,1.4-1.02.42,0,.83.09,1.24.28l-.27.63c-.3-.2-.62-.28-.92-.28s-.62.07-.62.38c0,.26.32.38.58.5l.44.2c.55.26.88.55.88,1.12,0,.76-.65,1.1-1.43,1.1-.43,0-.89-.08-1.32-.28l.27-.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M114.86,196.06c1.21,0,2.06.7,2.06,1.96s-.85,1.96-2.06,1.96-2.07-.69-2.06-1.96c0-1.26.85-1.96,2.06-1.96ZM114.86,199.28c.77,0,1.21-.54,1.21-1.27s-.45-1.27-1.21-1.27-1.21.54-1.21,1.27.45,1.27,1.21,1.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M119.29,199.05c.34.19.68.3,1.04.3s.61-.12.61-.46c0-.3-.31-.46-.6-.59l-.46-.2c-.51-.23-.84-.5-.84-1.02,0-.7.66-1.02,1.4-1.02.42,0,.83.09,1.24.28l-.27.63c-.3-.2-.62-.28-.92-.28s-.62.07-.62.38c0,.26.32.38.58.5l.44.2c.55.26.88.55.88,1.12,0,.76-.65,1.1-1.43,1.1-.43,0-.89-.08-1.32-.28l.27-.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M122.33,196.12h.77v3.79h-.77v-3.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M127.43,196.06c.4,0,.78.09,1.11.26l-.3.6c-.18-.1-.42-.18-.71-.18-.76,0-1.25.52-1.25,1.27,0,.79.55,1.29,1.32,1.29.34,0,.57-.09.79-.19l-.08.69c-.19.08-.49.17-.87.17-1.17,0-2.01-.76-2-1.97,0-1.21.85-1.96,2-1.96Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M130.85,196.06c1.21,0,2.06.7,2.06,1.96s-.85,1.96-2.06,1.96-2.07-.69-2.06-1.96c0-1.26.85-1.96,2.06-1.96ZM130.85,199.28c.77,0,1.21-.54,1.21-1.27s-.45-1.27-1.21-1.27-1.21.54-1.21,1.27.45,1.27,1.21,1.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M133.53,199.05c.34.19.68.3,1.04.3s.61-.12.61-.46c0-.3-.31-.46-.6-.59l-.46-.2c-.51-.23-.84-.5-.84-1.02,0-.7.66-1.02,1.4-1.02.42,0,.83.09,1.24.28l-.27.63c-.3-.2-.62-.28-.92-.28s-.62.07-.62.38c0,.26.32.38.58.5l.44.2c.55.26.88.55.88,1.12,0,.76-.65,1.1-1.43,1.1-.43,0-.89-.08-1.32-.28l.27-.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M137.4,196.77h-1.2v-.65h3.18l-.09.65h-1.12v3.14h-.77v-3.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M141.83,196.12c.83,0,1.2.59,1.2,1.14,0,.61-.43,1.07-.94,1.09.55.14.62.56.81,1.01.08.18.21.43.31.55h-.9c-.07-.06-.17-.24-.24-.44-.19-.52-.27-.93-.83-.93h-.28c-.34,0-.37-.15-.44-.27v1.64h-.77v-3.79h2.08ZM140.52,197.59c0,.21.12.34.44.34h.63c.42,0,.61-.25.61-.59,0-.45-.24-.6-.62-.6h-1.06v.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M143.58,196.12h.77v2.36c0,.6.43.82.9.82.51,0,.9-.24.9-.82v-2.36h.71v2.46c0,.97-.72,1.4-1.61,1.4-.82,0-1.67-.37-1.67-1.4v-2.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M147.57,196.12h.77v3.79h-.77v-3.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M149.12,199.05c.34.19.68.3,1.04.3s.61-.12.61-.46c0-.3-.31-.46-.6-.59l-.46-.2c-.51-.23-.84-.5-.84-1.02,0-.7.66-1.02,1.4-1.02.42,0,.83.09,1.24.28l-.27.63c-.3-.2-.62-.28-.92-.28s-.62.07-.62.38c0,.26.32.38.58.5l.44.2c.55.26.88.55.88,1.12,0,.76-.65,1.1-1.43,1.1-.44,0-.89-.08-1.32-.28l.27-.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M153.99,196.06c.4,0,.78.09,1.11.26l-.3.6c-.18-.1-.42-.18-.71-.18-.76,0-1.25.52-1.25,1.27,0,.79.55,1.29,1.32,1.29.34,0,.57-.09.79-.19l-.08.69c-.19.08-.49.17-.87.17-1.17,0-2.01-.76-2-1.97,0-1.21.85-1.96,2-1.96Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M156.47,199.91c-.56,0-.97-.32-.97-.89v-2.9h2.66l-.11.63h-1.78v.96h1.61l-.1.61h-1.5v.54c0,.26.11.41.39.41h1.47l-.11.63h-1.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M160.47,196.12h.77v3.79h-.77v-3.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M164.38,199.91l-1.72-2.75v2.75h-.68v-3.79h.9l1.67,2.71v-2.71h.68v3.79h-.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M166.02,199.05c.34.19.68.3,1.04.3s.61-.12.61-.46c0-.3-.31-.46-.6-.59l-.46-.2c-.51-.23-.84-.5-.84-1.02,0-.7.66-1.02,1.4-1.02.42,0,.83.09,1.24.28l-.27.63c-.3-.2-.62-.28-.92-.28s-.62.07-.62.38c0,.26.32.38.58.5l.44.2c.55.26.88.55.88,1.12,0,.76-.65,1.1-1.43,1.1-.43,0-.89-.08-1.32-.28l.27-.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M169.04,196.12h.77v3.79h-.77v-3.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M171.5,199.91c-.56,0-.97-.32-.97-.89v-2.9h2.66l-.11.63h-1.78v.96h1.61l-.1.61h-1.5v.54c0,.26.11.41.39.41h1.47l-.11.63h-1.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M173.74,199.91v-3.79h1.24l.77,2.5h.01l.81-2.5h1.23v3.79h-.77v-3.19s0,0,0,0l-1.02,3.19h-.6l-.98-3.19h-.02v3.19s-.67,0-.67,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M179.49,199.91c-.56,0-.97-.32-.97-.89v-2.9h2.66l-.11.63h-1.78v.96h1.61l-.1.61h-1.5v.54c0,.26.11.41.39.41h1.47l-.11.63h-1.56Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWeareoneLogo);
export default __webpack_public_path__ + "static/media/weareone-logo.cf60c52c1cba9ccf6f6e72cfd660d802.svg";
export { ForwardRef as ReactComponent };